import { useEffect, useState } from 'react';
import { DEFAULT_LOCATION, getVisitorLocation } from '../utils/geolocation';

// React equivalent of the PHP app's per-session geolocation lookup: resolves
// once (cached in localStorage by getVisitorLocation), starting from the USD
// default so pricing renders immediately and swaps in the detected currency.
export default function useVisitorLocation() {
  const [location, setLocation] = useState(DEFAULT_LOCATION);
  const [isDetecting, setIsDetecting] = useState(true);

  useEffect(() => {
    let isMounted = true;

    getVisitorLocation()
      .then((loc) => {
        if (isMounted) setLocation(loc);
      })
      .finally(() => {
        if (isMounted) setIsDetecting(false);
      });

    return () => { isMounted = false; };
  }, []);

  return { ...location, isDetecting };
}
